import BookingsCountLabel from 'components/Common/Labels/BookingsCountLabel'
import OfferLabels from 'components/Common/Labels/OfferLabels'
import PerfectForGroupsLabel from 'components/Common/Labels/PerfectForGroupsLabel'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import { useContext, type ComponentProps } from 'react'
import { shouldShowPerfectForGroupsLabel } from 'lib/charterFlights/kidsFlyFreeUtils'
import TheresNoPlaceLikeHomeCampaignLabel from 'components/Common/Labels/TheresNoPlaceLikeHomeCampaignLabel'
import GeoContext from 'contexts/geoContext'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import useFeatureFlag from 'hooks/Optimizely/useFeatureFlag'
import { offerHasTheresNoPlaceLikeHomeCampaignTag } from 'lib/offer/theresNoPlaceLikeHomeCampaignTag'

type InheritedOfferLabelsProps = ComponentProps<typeof OfferLabels>

interface Props extends InheritedOfferLabelsProps {
  offer: App.Offer | App.OfferSummary
  showBadge?: boolean
}

function OfferPageLabelGroup(props: Props) {
  const {
    offer,
    showBadge,
    ...offerLabelProps
  } = props

  const bookings = offer.stats.booked
  const { currentRegionCode } = useContext(GeoContext)
  const isNoPlaceLikeHomeCampaignEnabled = useFeatureFlag(OptimizelyFeatureFlags.noPlaceLikeHomeCampaign)
  const showTheresNoPlaceLikeHomeLabel = currentRegionCode === 'AU' && isNoPlaceLikeHomeCampaignEnabled && offerHasTheresNoPlaceLikeHomeCampaignTag(offer.campaignTags)

  return <LabelGroup>
    {shouldShowPerfectForGroupsLabel(offer) && <PerfectForGroupsLabel />}
    <OfferLabels
      {...offerLabelProps}
      offer={offer}
      onOfferPage
      suppressTheresNoPlaceLikeHomeCampaignLabel
    />
    <BookingsCountLabel bookings={bookings} threshold="offer" />
    {showTheresNoPlaceLikeHomeLabel && <TheresNoPlaceLikeHomeCampaignLabel />}
    {showBadge && !!offer.badge && <OfferBadgeLabel badge={offer.badge} />}
  </LabelGroup>
}

export default OfferPageLabelGroup
